import { addNotify } from 'features/notify';
import initialState from './initial';

export const actionTypes = {
  ACTION_PROCESSING: 'sportHistory/ACTION_PROCESSING',
  GET_SPORT_HISTORY: 'sportHistory/GET_SPORT_HISTORY',
  GET_BETS_MAPPING: 'sportHistory/GET_BETS_MAPPING',
  GET_COUPON_BETS: 'sportHistory/GET_COUPON_BETS',
};

const setActionProcessing = actionProcessing => async dispatch => {
  dispatch({
    type: actionTypes.ACTION_PROCESSING,
    payload: {
      [actionTypes.ACTION_PROCESSING]: actionProcessing,
    },
  });
};

const getSportHistory = formData => async (dispatch, getState, extra) => {
  const { api } = extra;

  dispatch(setActionProcessing(true));
  const response = await api.sportHistory.getSportHistory(formData);

  function dispatchGetSportHistory(data) {
    dispatch({
      type: actionTypes.GET_SPORT_HISTORY,
      payload: {
        [actionTypes.GET_SPORT_HISTORY]: data
      },
    });
  }

  if (response.success && response.data) {
    dispatchGetSportHistory(response.data);
  } else {
    dispatchGetSportHistory(initialState.coupons);
  }

  dispatch(setActionProcessing(false));
};

const getCouponBets =
  ({ id, callback, errorCallback }) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    const localeError = getState().locale.errorStatusMessage;

    dispatch(setActionProcessing(true));
    const response = await api.sportHistory.getCouponBets(id);

    if (response.success && response.data) {
      callback(response.data);
    } else {
      errorCallback();
    }

    dispatch(setActionProcessing(false));
  };

export { getSportHistory, getCouponBets };
